"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.spa = exports.serverData = void 0;
var preloadedState = typeof window === 'object' && window ? window.__PRELOADED_STATE__ : {};
var isSpa = typeof window === 'object' && window ? window.__ISSPA__ : true;
if (isSpa === undefined) {
    isSpa = true;
}
function serverData() {
    return preloadedState;
}
exports.serverData = serverData;
function spa() {
    return isSpa;
}
exports.spa = spa;
//# sourceMappingURL=serverData.js.map